import _ from 'lodash'

export default function getTitle(item = {}) {
  let title = _.get(item, 'title');
  if (_.get(item, '_type') === "channel") {
    if (!Boolean(["user", "organization"].includes(_.get(item, 'owner._type', "user")))) {
      title = _.get(item, 'owner.title', _.get(item, 'owner.name'));
    }
  } else if (["teacher", "student", "course_enrollment"].includes(_.get(item, '_type'))) {
    title = _.get(item, 'fullname');
  } else if (["god_word"].includes(_.get(item, '_type'))) {
    title = _.get(item, 'content');
  }

  if (title) return title
  return _.get(item, 'name', '')
}

